import React, { CSSProperties } from "react";

import { Header } from "semantic-ui-react";

const IMAGES = {
  logo: "/static/images/landing/mehealth-logo.png",
} as const;

type LandingContainerProps = {
  children: React.ReactNode;
  logoSrc?: string;
  subtitle?: string;
  subtitleStyle?: CSSProperties;
  title?: string;
};

type Styles = Record<"container" | "headerSection" | "logo", CSSProperties>;

const styles: Styles = {
  container: {
    maxWidth: "36rem",
    width: "100%",
  },
  headerSection: {
    marginBottom: "1.8rem",
    textAlign: "center",
  },
  logo: {
    alignItems: "center",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto 1rem auto",
    width: "135px",
  },
};

const LandingContainer: React.FC<LandingContainerProps> = (props) => (
  <div style={styles.container}>
    <div style={styles.headerSection}>
      {/* <img style={{ ...styles.logo }} alt="logo" src={props.logoSrc || IMAGES.logo} />
      <Header
        style={{
          fontSize: "1.5rem",
          marginBottom: "2.5rem",
        }}
        as="h2"
      >
        {props.title || "ลงชื่อเข้าใช้งาน"}{" "}
        <span style={{ color: "var(--primary-theme-color)", ...props.subtitleStyle }}>
          {props.subtitle ?? "MeHealth"}
        </span>
      </Header> */}
      <Header
        style={{
          fontSize: "2rem",
          marginBottom: "2rem",
          display: "inline-block",
          borderBottom: "4px solid var(--primary-theme-color)",
          padding: "4px 1rem 0 1rem",
        }}
        as="h2"
      >
        {props.title || "ลงชื่อเข้าใช้งาน"}
      </Header>
    </div>

    {props.children}
  </div>
);

export default LandingContainer;
